const DEFAULT_MESSAGE = 'La date doit être antérieure à la date du jour';

export const mustBeBeforeDate =
  (date?: Date, message?: string, allowEmpty: boolean = true) =>
  (value: string) => {
    const msg = message || DEFAULT_MESSAGE;

    if (allowEmpty && !value) return undefined;
    const [day, month, year] = value.split('/').map((v) => Number(v));

    const today = date || new Date();
    const thedate = new Date(year, month - 1, day);
    const isBeforeOrEqual = thedate <= today;

    return isBeforeOrEqual ? undefined : msg;
  };
